module.exports = __webpack_public_path__ + "static/img/8.13e801d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/5/3/sp/8.png
// module id = 7S4r
// module chunks = 0